import * as React from 'react';
import styled from '@emotion/styled';
import { Icon } from './Icon';

export interface CrumbItem { label: React.ReactNode; href?: string; }

export interface BreadcrumbProps {
  items: Array<string | CrumbItem>;
  className?: string;
}

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.fg.subtle};
`;
const Link = styled.a`
  color: ${({ theme }) => theme.color.fg.muted};
  text-decoration: none;
  &:hover { color: ${({ theme }) => theme.color.fg.default}; }
`;
const Current = styled.span`color: ${({ theme }) => theme.color.fg.default}; font-weight: ${({ theme }) => theme.fontWeight.medium};`;

/** Lumen breadcrumb — chevron-separated path; last item is the current page. */
export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <Nav aria-label="Breadcrumb" className={className}>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        const label = typeof it === 'string' ? it : it.label;
        const href = typeof it === 'string' ? undefined : it.href;
        return (
          <React.Fragment key={i}>
            {last ? <Current>{label}</Current> : <Link href={href ?? '#'}>{label}</Link>}
            {!last && <Icon name="chevRight" size={12} />}
          </React.Fragment>
        );
      })}
    </Nav>
  );
}
